import { render, staticRenderFns } from "./AnaliseVendas.vue?vue&type=template&id=09825de2&scoped=true"
import script from "./AnaliseVendas.vue?vue&type=script&lang=js"
export * from "./AnaliseVendas.vue?vue&type=script&lang=js"
import style0 from "./AnaliseVendas.vue?vue&type=style&index=0&id=09825de2&prod&lang=css"
import style1 from "./AnaliseVendas.vue?vue&type=style&index=1&id=09825de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09825de2",
  null
  
)

export default component.exports